import AdsService from '~/services/ads.service';
import { EXPENSES } from '~/lib/constants';
import { gameSelectors, uiActions, turnSelectors, inboxActions, loadingActions } from '~/store';
// --- internal imports ------

import * as types from './actionTypes';
// --- local imports ------

export function fetchBoughtAds() {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());
		const result = await AdsService.fetchBoughtAds(gameUserId);
		if (!result.isSuccess) {
			return;
		}
		
		const boughtAds = result.data;
		dispatch({ type: types.ADS_BOUGHT_ADS_LOADED, boughtAds });
	};
}

export function fetchAvailableAds() {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());

		const result = await AdsService.fetchAvailableAds(gameUserId);
		if (!result.isSuccess) {
			return;
		}

		const availableAds = result.data;
		dispatch({ type: types.ADS_AVAILABLE_ADS_LOADED, availableAds });
	};
}

export function hireAd(adId) {
	return async (dispatch, getState) => {
		const gameUserId = gameSelectors.getGameId(getState());
		const startingTurnDate = turnSelectors.getTurnDate(getState());
		dispatch(loadingActions.start(types.ADS_RENT));

		const result =  await AdsService.hireAd(adId, startingTurnDate, gameUserId);
		if (!result.isSuccess) {
			dispatch(loadingActions.endAfterNetworkFaliures());
			return false;
		}

		const { runningAd: boughtAd, notifications } = result.data;
		dispatch({ type: types.ADS_RENT, boughtAd });
		dispatch(inboxActions.handleNewMessage(notifications));
		dispatch( uiActions.addNewExpenseToDisplay(EXPENSES.ADS, boughtAd.price ));
		dispatch(loadingActions.end(types.ADS_RENT));
		return true;
	};
}

export function stopRunningAd(stoppedAdId) {
	return async (dispatch, getState) => {
		const endingTurnDate = turnSelectors.getTurnDate(getState());
		dispatch(loadingActions.start(types.ADS_STOP));
		const result = await AdsService.stopRunningAd(stoppedAdId, endingTurnDate);

		if (!result.isSuccess) {
			dispatch(loadingActions.endAfterNetworkFaliures());
			return false;
		}

		const stopAdSuccessful = result.data;
		await dispatch(loadingActions.end(types.ADS_STOP));
		if (stopAdSuccessful) {
			dispatch({ type: types.ADS_STOP, stoppedAdId, endingTurnDate });
		}

		return true;
	};
}
